/*
This file is sourced from the OfficeHome repo. Ensure it is always kept in sync with it.
https://office.visualstudio.com/DefaultCollection/OC/_git/OfficeHome?path=/services/OfficeHome/OfficeHome.Common/Models/Host.cs
*/
export var Host;
(function (Host) {
    /**
     * host from office.com
     */
    Host["Office"] = "Office";
    /**
     * host from microsoft365.com
     */
    Host["Microsoft365"] = "Microsoft365";
    /**
     * host from m365.go.microsoft
     */
    Host["M365Go"] = "M365Go";
    /**
     * host from m365.cloud.microsoft
     */
    Host["M365Cloud"] = "M365Cloud";
    /**
     * host from copilot.cloud.microsoft
     */
    Host["CCM"] = "CCM";
    /**
     * host from copilot.cloud-dev.microsoft
     */
    Host["CCMDev"] = "CCMDev";
    /**
     * host from ccm.mobile.m365.svc.cloud.microsoft
     */
    Host["CCMDevLocal"] = "CCMDevLocal";
    /**
     * host from other domains
     */
    Host["Other"] = "Other";
})(Host || (Host = {}));
//# sourceMappingURL=Host.js.map